import ActionTypes from '../constants/ActionTypes';
import Events from '../constants/Events';
import {
    FETCH_INVITATION_FAILED,
    FETCH_INVITATION_SUCCESS,
    FETCH_INVITATIONS_FAILED,
    FETCH_INVITATIONS_SUCCESS,
    FETCH_USER_CLIENTS_FAILED,
    FETCH_USER_CLIENTS_SUCCESS,
    FETCH_USERS_FAIL,
    FETCH_USERS_SUCCESS,
    FETCHING_INVITATION,
    FETCHING_INVITATIONS,
    FETCHING_USER_CLIENTS,
    FETCHING_USERS,
    REINVITING_USER,
    REINVITE_USER_SUCCESS,
    REINVITE_USER_FAILED,
    APPROVING_INVITATION,
    APPROVING_INVITATION_SUCCESS,
    APPROVING_INVITATION_FAILED,
    BULK_APPROVING_INVITATIONS,
    BULK_APPROVE_INVITATIONS_SUCCESS,
    BULK_APPROVE_INVITATIONS_FAILED,
    BULK_REINVITING_USERS,
    BULK_REINVITING_USERS_SUCCESS,
    BULK_REINVITING_USERS_FAILED,
    REFRESH_TOKEN_FAILED,
    REFRESH_TOKEN_SUCCESS,
    REFRESHING_TOKEN,
    LINKING_INVITATION,
    LINK_INVITATION_SUCCESS,
    LINK_INVITATION_FAILURE,
    CREATING_INVITATIONS_FAILED,
    CREATING_INVITATIONS_SUCCESS,
    CREATING_INVITATIONS,
    REMOVING_USER,
    REMOVING_USER_FAILED,
    REMOVING_USER_SUCCESS,
    REMOVING_USER_RESET,
    CLEARING_STORE,
    SETTING_INACTIVE_DATE,
    SET_INACTIVE_DATE_SUCCESS,
    SET_INACTIVE_DATE_FAILURE,
    UPDATING_INVITATION,
    UPDATE_INVITATION_SUCCESS,
    UPDATE_INVITATION_FAILURE,
    REFRESH_USER_DETAILS,
    USER_DETAILS_REFRESHED,
    SET_USER_INFO
} from '../actions/AuthActions';

import { clearToken } from '../functions/AuthenticationFunctions';

export default function reducer(
    state = {
        refresh: false,
        isLoading: false,
        loggedIn: false,
        error: null,
        user: null,
        users: [],
        userClients: null,
        isPasswordReset: false,
        isPasswordChanged: false,
        invitations: [],
        linkSuccess: false,
        response: null,
        invitation: null,
        createInvitesResponse: null,
        createInvitesError: null,
        bulkReinviteResponse: null,
        bulkReinviteError: null,
        approval: null,
        approvalError: null,
        updateInvitationResponse: null,
        setInactiveDateResponse: null
    },
    action
) {
    switch (action.type) {
        case Events.LOGIN_SUCCESS: {
            return {
                ...state,
                loggedIn: true,
                isLoading: false,
                error: null
            };
        }
        case Events.LOGIN_FAILED: {
            return {
                ...state,
                isLoading: false,
                loggedIn: false,
                error: action.payload
            };
        }
        case ActionTypes.LOGIN: {
            return { ...state, isLoading: false, isPasswordReset: false, error: undefined };
        }
        case ActionTypes.LOGOUT: {
            return { ...state, isLoading: true };
        }
        case Events.LOGOUT_SUCCESS: {
            clearToken();
            return {
                ...state,
                error: undefined,
                loggedIn: false,
                user: undefined
            };
        }
        case Events.LOGOUT_FAILED: {
            return { ...state, error: action.payload };
        }
        case REFRESH_USER_DETAILS: {
            return { ...state, refresh: true };
        }
        case USER_DETAILS_REFRESHED: {
            return { ...state, refresh: false };
        }
        case SET_USER_INFO: {
            return { ...state, user: action.user, loggedIn: true };
        }
        case FETCHING_USERS: {
            return { ...state, isLoading: true, error: null, response: null };
        }
        case FETCH_USERS_SUCCESS: {
            return { ...state, isLoading: false, error: null, users: action.payload };
        }
        case FETCH_USERS_FAIL: {
            return { ...state, isLoading: false, users: [], error: action.payload };
        }
        case ActionTypes.CREATE_SALESFORCE: {
            return { ...state, isLoading: true, error: null, isRegistered: false };
        }
        case Events.CREATE_SALESFORCE_SUCCESS: {
            return { ...state, isLoading: false, error: null, isRegistered: true };
        }
        case Events.CREATE_SALESFORCE_FAIL: {
            return { ...state, isLoading: false, error: action.payload, isRegistered: false };
        }
        case ActionTypes.RESET_PASSWORD: {
            return { ...state, isLoading: true, error: null, isPasswordReset: false };
        }
        case Events.RESET_PASSWORD_SUCCESS: {
            return { ...state, isLoading: false, error: null, isPasswordReset: true };
        }
        case Events.RESET_PASSWORD_FAILED: {
            return { ...state, isLoading: false, error: action.payload, isPasswordReset: false };
        }
        case ActionTypes.CHANGE_PASSWORD: {
            return {
                ...state,
                isLoading: true,
                error: null,
                isPasswordChanged: false,
                passwordIsChanging: action.passwordIsChanging
            };
        }
        case Events.CHANGE_PASSWORD_SUCCESS: {
            return {
                ...state,
                isLoading: false,
                error: null,
                isPasswordChanged: true,
                passwordIsChanging: action.passwordIsChanging
            };
        }
        case Events.CHANGE_PASSWORD_FAILED: {
            return {
                ...state,
                isLoading: false,
                error: action.payload,
                isPasswordChanged: false,
                passwordIsChanging: action.passwordIsChanging
            };
        }
        case FETCHING_USER_CLIENTS: {
            return { ...state, isLoading: true, error: null, userClients: null };
        }
        case FETCH_USER_CLIENTS_SUCCESS: {
            return { ...state, isLoading: false, userClients: action.payload };
        }
        case FETCH_USER_CLIENTS_FAILED: {
            return { ...state, isLoading: false, userClients: null, error: action.payload };
        }
        case FETCHING_INVITATION: {
            return { ...state, isLoading: true, error: null };
        }
        case FETCH_INVITATION_SUCCESS: {
            return { ...state, isLoading: false, invitation: action.payload.data };
        }
        case FETCH_INVITATION_FAILED: {
            return { ...state, isLoading: false, invitation: null, error: action.payload };
        }
        case FETCHING_INVITATIONS: {
            return { ...state, isLoading: true, error: null, response: null };
        }
        case FETCH_INVITATIONS_SUCCESS: {
            return { ...state, isLoading: false, invitations: action.payload };
        }
        case FETCH_INVITATIONS_FAILED: {
            return { ...state, isLoading: false, invitations: [], error: action.payload };
        }
        case Events.RESET_IS_PASSWORD_CHANGED: {
            return { ...state, isPasswordChanged: false };
        }
        case REFRESHING_TOKEN: {
            return { ...state, isLoading: true };
        }
        case REFRESH_TOKEN_SUCCESS: {
            return { ...state, isLoading: false };
        }
        case REFRESH_TOKEN_FAILED: {
            return { ...state, isLoading: false, err: action.payload };
        }
        case LINKING_INVITATION: {
            return { ...state, isLoading: true, error: null, linkSuccess: false };
        }
        case LINK_INVITATION_SUCCESS: {
            return { ...state, isLoading: false, linkSuccess: true };
        }
        case LINK_INVITATION_FAILURE: {
            return { ...state, error: action.payload, isLoading: false, linkSuccess: false };
        }
        case CREATING_INVITATIONS: {
            return { ...state, isLoading: true, createInvitesError: null, createInvitesResponse: null };
        }
        case CREATING_INVITATIONS_SUCCESS: {
            return { ...state, isLoading: false, createInvitesResponse: action.payload };
        }
        case CREATING_INVITATIONS_FAILED: {
            return { ...state, isLoading: false, createInvitesError: action.payload };
        }
        case REINVITING_USER: {
            return { ...state, isLoading: true, error: null, response: null };
        }
        case REINVITE_USER_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false, error: null, response: action.payload
            });
        }
        case REINVITE_USER_FAILED: {
            return { ...state, isLoading: false, error: action.payload };
        }
        case BULK_REINVITING_USERS: {
            return { ...state, isLoading: true, bulkReinviteError: null, bulkReinviteResponse: null };
        }
        case BULK_REINVITING_USERS_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false, bulkReinviteError: null, bulkReinviteResponse: action.payload
            });
        }
        case BULK_REINVITING_USERS_FAILED: {
            return { ...state, isLoading: false, bulkReinviteError: action.payload };
        }
        case APPROVING_INVITATION: {
            return { ...state, isLoading: true, approvalError: null, approval: null };
        }
        case APPROVING_INVITATION_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false, approvalError: null, approval: action.payload
            });
        }
        case APPROVING_INVITATION_FAILED: {
            return { ...state, isLoading: false, approvalError: action.payload };
        }
        case BULK_APPROVING_INVITATIONS: {
            return { ...state, isLoading: true, error: null, response: null };
        }
        case BULK_APPROVE_INVITATIONS_SUCCESS: {
            return Object.assign({}, state, {
                isLoading: false, response: action.payload
            });
        }
        case BULK_APPROVE_INVITATIONS_FAILED: {
            return { ...state, isLoading: false, error: action.payload };
        }
        case REMOVING_USER: {
            return { ...state, isLoading: true, removeUserResponse: null, removeUserError: null };
        }
        case REMOVING_USER_SUCCESS: {
            return { ...state, isLoading: false, removeUserResponse: action.payload, removeUserError: null };
        }
        case REMOVING_USER_FAILED: {
            return { ...state, isLoading: false, removeUserResponse: null, removeUserError: action.payload };
        }
        case REMOVING_USER_RESET: {
            return { ...state, removeUserError: null, removeUserResponse: null };
        }
        case SETTING_INACTIVE_DATE: {
            return { ...state, isLoading: true, setInactiveDateResponse: null };
        }
        case SET_INACTIVE_DATE_SUCCESS: {
            let updatedUsers = state.users.map(user => {
                if (user.id === action.payload.userId) {
                    let clients = user.clients;
                    clients.forEach(client => {
                        if (client.clientId === action.payload.clientId) {
                            client.inactiveDate = action.payload.inactiveDate;
                        }
                    });
                }
                return user;
            });
            return {
                ...state,
                isLoading: false,
                users: updatedUsers,
                setInactiveDateResponse: action.payload.response
            };
        }
        case SET_INACTIVE_DATE_FAILURE: {
            return { ...state, isLoading: false, error: action.payload };
        }
        case UPDATING_INVITATION: {
            return { ...state, isLoading: true, updateInvitationResponse: null };
        }
        case UPDATE_INVITATION_SUCCESS: {
            return {
                ...state,
                invitations: state.invitations?.map(inv => (inv.id === action.payload.id) ? action.payload : inv),
                invitation: action.payload,
                isLoading: false,
                updateInvitationResponse: action.payload
            };
        }
        case UPDATE_INVITATION_FAILURE: {
            return { ...state, isLoading: false, error: action.payload };
        }
        case CLEARING_STORE: {
            return {
                ...state,
                createInvitesError: null,
                createInvitesResponse: null,
                approval: null,
                approvalError: null,
                bulkReinviteResponse: null,
                bulkReinviteError: null,
                setInactiveDateResponse: null,
                updateInvitationResponse: null
            };
        }
        default:
            return state;
    }
}
